<template>
  <vue-drawer-layout
    ref="sidePanel"
    :drawer-width="dww"
    @slide-end="handleContentFrame"
    @slide-move="handleContentFrame"
    :content-drawable="true"
    :enable="false"
    :backdrop="false"
    :z-index="0"
  >
    <div class="drawer-content" slot="drawer" style="border:1px solid white">
      <slot name="drawer"></slot>
    </div>
    <div slot="content">drawer</div>
  </vue-drawer-layout>
</template>

<script>
export default {
  name: "r-panel",
  props: {
    logo: {
      type: String,
      default: null
    },
    invoiceGroups: {
      type: Array,
      default: function() {
        return [{ Α: "Α" }];
      }
    },
    ilinks: {
      type: Array,
      default: function() {
        return null;
      }
    }
  },
  data() {
    return {
      submenuOpen: false,
      links: [
        {
          url: "/invoices/?sira=invoice",
          label: "Τιμολογια",
          isInvoiceHandler: true
        },
        { url: "/vy-businesss.html", label: "Πελατες" },
        { url: "/vy-sappliers.html", label: "Προμηθευτες" },
        {
          url: "/invoices/?sira=receipt",
          label: "ΑΠΥ"
        }
      ]
    };
  }
};
</script>

<style>
.top {
  display: flex;
  position: relative;
  background: #009688;
}
.menu {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
}
.menu-item a {
  color: #ffffff;
  padding: 1.5rem 0rem 1.5rem 0rem;
  display: block;
  cursor: pointer;
}
.menu-item a:hover {
  text-decoration: none;
}
.dropdown_menu {
  position: absolute;
  z-index: 1;
  background: #353a40;
}
.submenu-item a {
  padding: 0.5rem 1.5rem 0.5rem 1.5rem;
  display: block;
}
.business_logo img {
  height: 25px;
  margin: 15px 15px 0px 15px;
  cursor: pointer;
}
</style>
